import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchDetailFailed,
  fetchDetailRequested,
  fetchDetailSucceeded,
  fetchSummaryFailed,
  fetchSummaryRequested,
  fetchSummarySucceeded,
} from './croRedux';
import { getCRODetail, getCROSummary } from './croSummary.service';

const getErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : 'Unable to load contract renewal and remediation';

export function* fetchSummaryWorker(action: ReturnType<typeof fetchSummaryRequested>) {
  try {
    const result = yield call(getCROSummary, action.payload);
    yield put(fetchSummarySucceeded(result));
  } catch (error) {
    yield put(fetchSummaryFailed(getErrorMessage(error)));
  }
}

export function* fetchDetailWorker(action: ReturnType<typeof fetchDetailRequested>) {
  try {
    const { initiative, filters } = action.payload;
    const result = yield call(getCRODetail, initiative, filters);
    yield put(fetchDetailSucceeded(result));
  } catch (error) {
    yield put(fetchDetailFailed(getErrorMessage(error)));
  }
}

export default function* croSaga() {
  yield takeLatest(fetchSummaryRequested.type, fetchSummaryWorker);
  yield takeLatest(fetchDetailRequested.type, fetchDetailWorker);
}
